import axios from 'axios';

const API_BASE_PATH =
  window.location.origin === 'http://localhost:3000'
    ? 'http://localhost:8080/api/v1'
    : '/api/v1';

export const useApi = () => {
  const getVoterFileList = async () => {
    return await axios.get(`${API_BASE_PATH}/voter-file-list`);
  };
  const submitFileForUpload = async (id: string) => {
    return await axios.post(`${API_BASE_PATH}/voter-file-for-upload/${id}`);
  };
  const getCurrentlyUploadingFile = async () => {
    return await axios.get(`${API_BASE_PATH}/currently-uploading-voter-file`);
  };
  return { getVoterFileList, submitFileForUpload, getCurrentlyUploadingFile };
};
